import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { fetcheGiftShoppingApiThunk, fetchGiftInVoiceThunk, fetchMyGiftApiThunk, fetchMyStuffThunk } from './mystuffApis'

const initialState = {
	pointsData: [],
	totalCountOfPoints: 0,
	eGiftShoppingData: [],
	totalCountOfeGiftShopping: 0,
	myGiftData: [],
	totalCountOfMyGift: 0,
}

export const getMystuffData = createAsyncThunk('user/getMystuffData', fetchMyStuffThunk)
export const geteGiftShoppingData = createAsyncThunk('user/geteGiftShoppingData', fetcheGiftShoppingApiThunk)
export const getMyGiftData = createAsyncThunk('user/getMyGiftData', fetchMyGiftApiThunk)
export const downloadGiftInvoice = createAsyncThunk('user/giftIvoice', fetchGiftInVoiceThunk)
export const mystuffSlice = createSlice({
	name: 'myStuff',
	initialState,
	reducers: {
		// setUserProfileData: (state, action) => {
		// 	state.profileData = action.payload
		// },
	},
	extraReducers: (builder) => {
		builder.addCase(getMystuffData.fulfilled, (state, action) => {
			state.pointsData = action.payload?.data // Update the state with the profile data
			state.totalCountOfPoints = action?.payload?.count // Update the state with the profile data
		})
		builder.addCase(geteGiftShoppingData.fulfilled, (state, action) => {
			state.eGiftShoppingData = action?.payload?.data // Update the state with the profile data
			state.totalCountOfeGiftShopping = action?.payload?.total // Update the state with the profile data
		})
		builder.addCase(getMyGiftData.fulfilled, (state, action) => {
			state.myGiftData = action?.payload?.data // Update the state with the profile data
			state.totalCountOfMyGift = action?.payload?.total // Update the state with the profile data
		})
	},
})
// export const {} = teamsSlice.actions
export default mystuffSlice.reducer
